import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [

  {
    path: 'about',
    loadChildren: () => import('./components/about/about.module').then(m => m.AboutModule)
  },
  {
    path: 'token',
    loadChildren: () => import('./components/token-viewer/token-viewer.module').then(m => m.TokenViewerModule)
  },
  {
    path: ':embedCode/webar/informationBanner',
    loadChildren: () => import('./components/information-banner/information-banner.module').then(m => m.InformationBannerModule)
  },
  {
    path: ':embedCode/webar',
    loadChildren: () => import('./components/webar-loader/webar-loader.module').then(m => m.WebarLoaderModule)
  },

  {
    path: ':identifier',
    loadChildren: () => import('./components/main/main.module').then(m => m.MainModule)
  },
  {
    path: '',
    loadChildren: () => import('./components/share-code-form/share-code-form.module').then(m => m.ShareCodeFormModule)
  },
  {path: '**', redirectTo: ""}
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
